import type { AppRouteRecordRaw } from "@/types/router";
import HeaderLayout from "@/layouts/default/HeaderLayout.vue";

export const LAYOUT = () => import("@/layouts/default/index.vue");
export const HEADER_LAYOUT = () => import("@/layouts/default/HeaderLayout.vue");
export const whiteList = ["Policy", "Service", "WxLogin"];
export const redirectList = ["/no-access", "/bind", "/complete"];
export const constantsRoute: AppRouteRecordRaw[] = [
  {
    path: "/",
    name: "App",
    redirect: "/home",
    component: LAYOUT,
    meta: {
      title: "App",
    },
    children: [
      {
        path: "/home",
        name: "Home",
        component: () => import("@/views/app/home/index.vue"),
        meta: {
          title: "首页",
        },
      },
      {
        path: "/redirect/:path(.*)",
        name: "Redirect",
        component: () => import("@/views/app/redirect/index.vue"),
        meta: {
          title: "",
        },
      },
      {
        path: "/not-found",
        name: "NotFound",
        component: () => import("@/views/app/not-found/index.vue"),
        meta: {
          title: "NotFound",
        },
      },
    ],
  },
  {
    path: "/SYSTEM_LOGIN",
    name: "LoginParent",
    redirect: "/login",
    component: HeaderLayout,
    meta: {
      title: "",
    },
    children: [
      {
        path: "/login",
        name: "Login",
        component: () => import("@/views/app/login/index.vue"),
        meta: {
          title: "登录",
        },
      },

      {
        path: "/bind",
        name: "Bind",
        component: () => import("@/views/app/bind/index.vue"),
        meta: {
          title: "绑定手机号",
        },
      },
      {
        path: "/no-access",
        name: "NoAccess",
        component: () => import("@/views/app/no-access/index.vue"),
        meta: {
          title: "暂无访问权限",
        },
      },
      {
        path: "/complete",
        name: "Complete",
        component: () => import("@/views/app/complete/index.vue"),
        meta: {
          title: "完善资料",
        },
      },
      {
        path: "/policy",
        name: "Policy",
        component: () => import("@/views/app/policy/index.vue"),
        meta: {
          title: "服务协议",
        },
      },
      {
        path: "/service",
        name: "Service",
        component: () => import("@/views/app/service/index.vue"),
        meta: {
          title: "服务中心",
        },
      },
      {
        path: "/info",
        name: "UserInfo",
        component: () => import("@/views/user/info/index.vue"),
        meta: {
          title: "个人资料",
        },
      },
    ],
  },
  {
    path: "/SYSTEM_WX_LOGIN",
    name: "wxLoginParent",
    redirect: "/wxlogin",
    meta: {
      title: "",
    },
    children: [
      {
        path: "/wxlogin",
        name: "WxLogin",
        component: () => import("@/views/app/wxlogin/index.vue"),
        meta: {
          title: "微信登录",
        },
      },
    ],
  },
];
